<template>
	<div class="margin-top-20">
		<compWrapper title="客户费率" theme="primary">
			<compFormQuery v-if="query" class="margin-top-15" :formdata="getBase" :value="formData"></compFormQuery>
			<compFormEdit
				v-else
				ref="accountform"
				class="margin-top-15"
				:formdata="getBase"
				v-model="formData"
			></compFormEdit>
			<div class="text-right margin-right-20" v-if="type!='query'">
				<vButton theme="primary" class="margin-right-10" @click="submit">确定</vButton>
				<vButton @click="close">取消</vButton>
			</div>
		</compWrapper>
		<compWrapper v-if="type==='query'" title="操作历史" theme="primary">
			<compLog :data="logList" :columns="columns"></compLog>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>
<script>
import { HttpSystemList } from '@mods/service/base';
import { HttpGetCusRateOne, HttpSaveCusRateOne, HttpGetCusRateTemplate, HttpNewGetCusOrgWareList, HttpGetCusLineList } from '@/service/costbilling';
import { mapState, mapGetters } from 'vuex';
export default {
	components: {
		compWrapper: () => import('@components/templates/wrapper'),
		compFormQuery: () => import('@components/templates/formquery'),
		compFormEdit: () => import('@components/templates/formedit'),
		compLog: () => import("@components/templates/log"),
	},
	data() {
		return {
			loading: false,
			formData: {
				organizationName: '',
			},
			formOrgData: {
				rows: 20,
				page: 1,
				sidx: 'id',
				sord: 'desc',
				search: {
					CN_name: '',
				}
			},
			orgId: this.$store.state.organization.id,
			valuetext: 0,
			datalist: [],
			id: this.$route.query.id,
			temptype: this.$route.query.temptype,
			type: this.$route.params.type,
			syslist: [],
			logList: [],
			wareList: [],
			storeList: [],
			workServiceList: [],
			materialList: [],
			cusWareList: [],
			lineList: [],
		};
	},
	created() {
		this.query = this.type === "query";
		if (this.type != 'add') {
			this.getDetail()
			this.getTemplate()
		} else {
			this.getTemplate()
		}


	},
	computed: {
		...mapGetters('dictionary', ['getBillcusorgList', 'getCusproductList']),
		getBase() {
			return [

				{
					label: '组织',
					tag: 'vSelect',
					key: 'organizationId',
					show: this.type == 'add',
					options: this.getBillcusorgList,
					on: {
						'on-change': val => {
							this.getWareList(val)
						}
					},
					props: {
						filterable: true,
					}
				},
				{
					label: '组织',
					tag: 'vSelect',
					key: 'org_name',
					query: true,
					show: this.type == 'query' || this.type == 'edit',
					props: {
						filterable: true,
					}
				},
				{
					label: '仓库',
					tag: 'vSelect',
					key: 'orgWarehouseId',
					show: this.type == 'add',
					options: this.cusWareList,
					on: {
						'on-change': val => {
							this.getLineList(val)
						}
					},
					props: {
						filterable: true,
					}
				},
				{
					label: '仓库',
					tag: 'vSelect',
					key: 'orgWarehouseCode',
					show: this.type == 'query' || this.type == 'edit',
					query: true,
					props: {
						filterable: true,
					}
				},
				{
					label: '币种',
					tag: 'vSelect',
					key: 'currency',
					query: this.type == 'query' || this.type == 'edit',
					options: [
						{ value: 'USD', label: 'USD' }
					],
					formItem: {
						tip: this.type == 'query' || this.type == 'edit' ? '' : '<div class="color-error">币种一旦设置不可更改，请谨慎选择</div>',
					},

				},
				{
					label: "项目",
					key: 'lineId',
					tag: 'vSelect',
					options: this.lineList,
					show: this.type != 'query',
					required: false,
					props: {
						filterable: true,
						// multiple:true  多选操作
					}
				},
				{
					label: "项目",
					key: 'lineCode',
					tag: 'vInput',
					show: this.type == 'query',
					required: false,
					props: {
						filterable: true,
					}
				},
				{
					label: '仓库作业费模板',
					tag: 'vSelect',
					key: 'warehouseOperaterTemplateId',
					options: this.wareList,
				},
				{
					label: '仓储费模板',
					tag: 'vSelect',
					key: 'storageFeeTemplateId',
					options: this.storeList,
				},
				{
					label: '增值服务费模板',
					tag: 'vSelect',
					key: 'workServiceFeeTemplateId',
					options: this.workServiceList,
				},
				{
					label: '包材费模板',
					tag: 'vSelect',
					key: 'materialTemplateId',
					options: this.materialList,
				},
				{
					label: '备注',
					tag: 'vTextarea',
					key: 'remark',
					required: false,
				},
			]
		},
		columns() {
			let _this = this
			return [
				{
					title: "NO",
					type: 'index'
				},
				{
					title: "操作类型",
					key: 'operateTypeName'
				},
				{
					title: "字段",
					key: 'field'
				},
				{
					title: "修改前",
					key: 'beforeValue'
				},
				{
					title: "修改后",
					key: 'afterValue'
				},
				{
					title: "操作人",
					key: 'updatedName'
				},
				{
					title: "操作时间",
					key: 'updatedAt'
				},
			]
		},
	},
	methods: {
		getWareList(val) {
			this.cusWareList = [];
			this.lineList = []
			HttpNewGetCusOrgWareList({ customerOrgId: val }).then(res => {
				this.cusWareList = res.data.map(item => {
					return {
						value: item.id,
						label: item.code + ' (' + item.title + ')'
					}
				})
			}, err => {
				this.$VMessage.error(err.message);
			})
		},
		getDetail() {
			this.loading = true
			HttpGetCusRateOne({
				customerRateId: this.id,
				// page:1,
				// rows:1000,
			}).then(res => {
				this.formData = res.data
				this.logList = res.data.updateLog
				this.getLineList(this.formData.orgWarehouseId)
			}, err => {
				this.$VMessage.error(err.message);
			})

		},
		getLineList(val) {
			this.lineList = []
			HttpGetCusLineList({
				orgWarehouseId: val,
				customerRateId: this.id
			}).then(res => {
				this.lineList = res.data.map(item => {
					return {
						value: item.id,
						label: item.name
					}
				})
			})
		},
		getTemplate() {
			HttpGetCusRateTemplate({ type: 1 }).then(res => {
				this.wareList = res.data.map(item => {
					return {
						value: item.id,
						label: item.name + ' (' + item.code + ')'
					}
				})
			})
			HttpGetCusRateTemplate({ type: 4 }).then(res => {
				this.storeList = res.data.map(item => {
					return {
						value: item.id,
						label: item.name + ' (' + item.code + ')'
					}
				})
			})
			HttpGetCusRateTemplate({ type: 3 }).then(res => {
				this.workServiceList = res.data.map(item => {
					return {
						value: item.id,
						label: item.name + ' (' + item.code + ')'
					}
				})
			})
			HttpGetCusRateTemplate({ type: 5 }).then(res => {
				this.materialList = res.data.map(item => {
					return {
						value: item.id,
						label: item.name + ' (' + item.code + ')'
					}
				})
				this.loading = false
			})

		},
		close() {
			this.$router.push({
				name: 'costbillingRateBilllist',
			});
		},
		async submit() {
			const valid = await this.$refs['accountform'].validate();
			// console.log(!valid)
			if (!valid) return;

			this.loading = true
			HttpSaveCusRateOne({
				// customerOrgId:this.orgId,
				...this.formData
			}).then(res => {
				this.$VMessage.success(res.message);
				this.$router.push({
					name: 'costbillingRateBilllist',
				});
			}, err => {
				this.$VMessage.error(err.message);
			}).finally(result => {
				this.loading = false;
			})
		}
	}
};
</script>
